import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/contact")({
  component: ContactPage,
  head: () => ({
    meta: [
      { title: "Contact RKD Tile — Free Estimates in Utah" },
      {
        name: "description",
        content:
          "Get in touch with RKD Tile for custom tile, stone, and flooring in Park City, Salt Lake, and Utah County. Free estimates — response within 24 hours.",
      },
      { property: "og:title", content: "Contact RKD Tile for a Free Estimate in Utah" },
      { property: "og:url", content: "https://rkdtile.com/contact" },
      {
        property: "og:description",
        content:
          "Custom tile & stone estimates across Utah. Call (801) 598-2226 or send us your project details.",
      },
    ],
    links: [{ rel: "canonical", href: "https://rkdtile.com/contact" }],
  }),
});

function ContactPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <section className="py-20 md:py-24 bg-cream border-b border-border">
          <div className="container-prose text-center max-w-3xl mx-auto">
            <span className="eyebrow">Let's talk</span>
            <h1 className="mt-3 font-display text-4xl md:text-6xl text-foreground leading-tight">
              Contact
            </h1>
            <p className="mt-5 text-muted-foreground text-lg leading-relaxed">
              Tell us about your project. Robert personally responds to every
              inquiry within 24 hours.
            </p>
          </div>
        </section>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
